import { RESPONSIVE_BREAKPOINTS } from 'constants/Global/ResponsiveLayout.const';
import {
  Body as ItemBody,
  Card as ItemCard,
} from 'components/UI/Responsive/ItemCard';
import styled from 'styled-components';

export {
  Body,
  Code,
  Header,
  Heading,
  Hint,
  Parties,
  Quantity,
  Source,
  Title,
  Total,
} from 'components/UI/Responsive/ItemCard';

const tablet = `${RESPONSIVE_BREAKPOINTS.tablet}px`;

export const Card = styled(ItemCard)`
  display: flex;
  align-items: stretch;

  > ${ItemBody} {
    flex: 1;
    min-width: 0;
  }

  &[data-selected='true'] {
    border-color: #f78e1e;
  }
`;

export const Select = styled.label`
  display: flex;
  flex: none;
  align-items: flex-start;
  padding: 14px 0 12px 12px;
  cursor: pointer;

  @media (min-width: ${tablet}) {
    align-items: center;
    padding: 12px 0 12px 16px;
  }
`;

export const Status = styled.span`
  display: inline-flex;
  flex: none;
  gap: 4px;
  align-items: center;
  font-size: 11px;
  color: #595959;
  white-space: nowrap;
`;

export const StatusIcon = styled.span`
  display: inline-flex;
  font-size: 14px;

  img {
    width: 14px;
  }
`;

export const Countdown = styled.span`
  display: inline-block;
  margin-left: 8px;
  font-weight: 700;
  color: #d16d0f;

  p {
    display: inline;
    padding: 0 !important;
    margin: 0;
  }
`;

export const Placeholder = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 10px;
  padding: 12px;

  @media (min-width: ${tablet}) {
    padding: 12px 16px;
  }
`;

export const PlaceholderHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
`;

export const PlaceholderHeading = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 6px;
`;

export const PlaceholderFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
